import CircleIcon from '@mui/icons-material/Circle';
import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';

interface Props {
  assessment: Assessment | undefined;
}

const BoosterWords: React.FC<Props> = ({ assessment }) => {
  const { classes, cx } = useStyles();

  const wordList = assessment?.instructions?.descriptions?.wordlist;
  const wordListChunk = _.chunk(wordList, 2);

  return (
    <div className={classes.card}>
      {wordListChunk?.map((chunk, idx1) => (
        <Stack key={idx1} direction={'row'}>
          {chunk.map((word, idx2) => (
            <Stack key={idx2} className={cx(classes.boosterWord, idx1 === wordListChunk.length - 1 ? 'last-row' : undefined)}>
              <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                <CircleIcon className={classes.icon} />
                <Typography className={classes.text}>{word}</Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
      ))}
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  card: {
    width: '100%',
    background: '#FFF',
    padding: '8px 16px',
    borderRadius: '8px',
  },
  boosterWord: {
    borderBottom: `1px solid ${theme.palette.greys.light}`,
    marginBottom: '8px',
    paddingBottom: '8px',
    flex: 1,
    '&.last-row': {
      borderBottom: 'none',
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
  text: {
    fontSize: theme.typography.pxToRem(14),
  },
  icon: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.primary.main,
  },
}));

export default BoosterWords;
